/* eslint no-undef: 'off' */
import $ from 'jquery';
import { LocalStorage } from "storage-manager-js";
// import { localStorage } from "../customizer/__constant";

const ajax_faq_category_action = () => {
    $(document).on('click', '.faq_category_action', (event) => {
        const term_id   = $(event.target).data("term_id");
        const taxonomy  = $('#taxonomy_value').val();
        const parent    = $('#parent_value').val();

        const urlParams = new URLSearchParams(window.location.search);
        const localname = urlParams.get('pages');
        const section   = urlParams.get('section');

        const newObj = {
            [`${parent}-${taxonomy}`]: {
              "customizer-option": term_id.toString(),
            }
        };

        const customizerString  = LocalStorage.get(localname);
        const customizer        = JSON.parse(customizerString) || {};

        for (const [newObjKey, newObjValue] of Object.entries(newObj)) {
            customizer[newObjKey] = newObjValue;
        }

        LocalStorage.set(localname, JSON.stringify(customizer));

        const referrer = document.referrer;

        if (section) {
            const newURL = referrer + '#' + section;
            location.href = newURL;
        } else {
            location.href = referrer;
        }
    })

}
const init = () => {
    ajax_faq_category_action();
}

try {
    init();
} catch (error) {
    console.error(`This File error ${error}`);
}